(function() {
    class SocialReelsAdev extends HTMLElement {
      constructor() {
        super();
        this.carousel = null;
        this.prevButton = null;
        this.nextButton = null;
        this.scrollAmount = 0;
      }

      connectedCallback() {
        this.carousel = this.querySelector('[data-carousel]');
        this.prevButton = this.querySelector('[data-nav="prev"]');
        this.nextButton = this.querySelector('[data-nav="next"]');

        if (!this.carousel || !this.prevButton || !this.nextButton) return;

        this.calculateScrollAmount();
        this.updateButtonStates();
        this.setupEventListeners();
      }

      calculateScrollAmount() {
        const firstVideo = this.carousel.querySelector('.ai-social-reels__video-wrapper-adev');
        if (firstVideo) {
          const gap = parseInt(this.getAttribute('data-gap')) || 5;
          this.scrollAmount = firstVideo.offsetWidth + gap;
        }
      }

      setupEventListeners() {
        this.prevButton.addEventListener('click', () => this.scroll('prev'));
        this.nextButton.addEventListener('click', () => this.scroll('next'));
        
        this.carousel.addEventListener('scroll', () => {
          this.updateButtonStates();
        });

        window.addEventListener('resize', () => {
          this.calculateScrollAmount();
        });
      }

      scroll(direction) {
        const scrollDistance = direction === 'next' ? this.scrollAmount : -this.scrollAmount;
        this.carousel.scrollBy({
          left: scrollDistance,
          behavior: 'smooth'
        });
      }

      updateButtonStates() {
        const maxScroll = this.carousel.scrollWidth - this.carousel.clientWidth;
        const currentScroll = this.carousel.scrollLeft;

        this.prevButton.disabled = currentScroll <= 0;
        this.nextButton.disabled = currentScroll >= maxScroll - 1;
      }
    }

    customElements.define('social-reels-adev', SocialReelsAdev);
  })();